"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var store_1 = require("../../../store");
var response_1 = require("../../response");
var bulkMutationFunctions_1 = require("./bulkMutationFunctions");
var hooks_1 = require("../../../hooks");
function useBulkMutation(_a) {
    var method = _a.method, onSuccess = _a.onSuccess;
    var store = store_1.useStoreContext().store;
    var _b = __read(React.useState([]), 2), invocationKeys = _b[0], setInvocationKeys = _b[1];
    // get the states of any invocations
    var currentStates = store_1.useMappedStoreState(function (get) {
        if (!invocationKeys || invocationKeys.length < 1) {
            return undefined;
        }
        return invocationKeys.map(get);
    });
    var memoizedCurrentStates = hooks_1.useMemoizedObject(currentStates);
    var results = React.useMemo(function () {
        return currentStates &&
            currentStates.map(function (variant, index) {
                return (__assign(__assign({}, bulkMutationFunctions_1.processActionResult(variant)), { args: bulkMutationFunctions_1.getArgsFromInvocationKey(invocationKeys[index]) }));
            });
    }, [memoizedCurrentStates]);
    var aggregatedResult = React.useMemo(function () {
        if (!results) {
            return undefined;
        }
        return response_1.aggregateResults(results);
    }, [results]);
    // when the invocation variant changes, call their onSuccess method
    React.useEffect(function () {
        var resultSuccessful = aggregatedResult && !aggregatedResult.error && !aggregatedResult.loading;
        onSuccess && resultSuccessful && onSuccess(results);
    }, [JSON.stringify(aggregatedResult)]);
    var invoke = React.useCallback(function (args) {
        var newInvocationKeys = args.map(function (argSet) {
            var invocationKey = bulkMutationFunctions_1.createActionInvocationKey(method, argSet);
            bulkMutationFunctions_1.callMutationMethod(argSet, method, invocationKey, store);
            return invocationKey;
        });
        setInvocationKeys(newInvocationKeys);
        bulkMutationFunctions_1.clearOldState(invocationKeys, store);
    }, [method, setInvocationKeys]);
    var reset = React.useCallback(function () {
        setInvocationKeys([]);
        bulkMutationFunctions_1.clearOldState(invocationKeys, store);
    }, [invocationKeys]);
    return {
        invoke: invoke,
        reset: reset,
        results: results,
        aggregatedResult: aggregatedResult,
    };
}
exports.default = useBulkMutation;
//# sourceMappingURL=useBulkMutation.js.map